<template>
  <div class="bracket-final">
    <AppLoading v-if="!data || !teams" position="center" />
    <template v-if="data && teams">
      <!-- <BracketGroup
        group="A"
        :groupData="data.groupA"
        :teams="teams"
        class="bracket-final__group bracket-final__group_a"
      /> -->
      <!-- <BracketGroup
        group="B"
        :groupData="data.groupB"
        :teams="teams"
        class="bracket-final__group bracket-final__group_b"
      /> -->
      <!-- <BracketGroup
        group="C"
        class="bracket-final__group bracket-final__group_c"
      />
      <BracketGroup
        group="D"
        class="bracket-final__group bracket-final__group_d"
      /> -->

      <div class="bracket-final__after-groups">
        <div
          v-if="false"
          class="bracket-final__quarterfinal bracket-final__quarterfinal_left"
        >
          <BracketFinalMatch :match="data.quarterLeft[1]" :teams="teams" />
          <BracketFinalMatch :match="data.quarterLeft[2]" :teams="teams" />
        </div>

        <div class="bracket-final__semifinal bracket-final__semifinal_left">
          <BracketFinalMatch :match="data.semiLeft" :teams="teams" />
        </div>

        <BracketFinalWinner class="bracket-final__winner">
          {{ data.winner }}
        </BracketFinalWinner>

        <div class="bracket-final__final">
          <BracketFinalMatch :match="data.final" title="Финал" :teams="teams" />
        </div>

        <!-- <div class="bracket-final__third">
          <BracketFinalMatch
            :match="data.third"
            title="Матч за 3 место"
            :teams="teams"
          />
        </div> -->

        <div
          v-if="false"
          class="bracket-final__quarterfinal bracket-final__quarterfinal_right"
        >
          <BracketFinalMatch :match="data.quarterRight[1]" :teams="teams" />
          <BracketFinalMatch :match="data.quarterRight[2]" :teams="teams" />
        </div>

        <div class="bracket-final__semifinal bracket-final__semifinal_right">
          <BracketFinalMatch :match="data.semiRight" :teams="teams" />
        </div>

        <div class="bracket-final__line bracket-final__line_semi"></div>
        <div class="bracket-final__line bracket-final__line_final"></div>
      </div>
    </template>
  </div>
</template>

<script>
// import BracketGroup from "./BracketGroup";
import BracketFinalWinner from "./BracketFinalWinner";
import BracketFinalMatch from "./BracketFinalMatch";
import service from "@/services/brackets";

export default {
  name: "BracketFinalStage",
  components: {
    // BracketGroup,
    BracketFinalMatch,
    BracketFinalWinner
  },
  data: () => ({
    teams: null,
    data: null
  }),
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.teams = await service.getFinalTeams();
      this.data = await service.getFinalBracketsData();
    }
  }
};
</script>

<style lang="scss">
.bracket-final {
  height: 400px;
  width: 100%;
  position: relative;
  min-width: 1171px;

  &__group {
    position: absolute;
    &_a {
      top: 0;
      left: 0;
    }
    &_c {
      bottom: 0;
      left: 0;
    }
    &_b {
      top: 0;
      right: 0;
    }
    &_d {
      bottom: 0;
      right: 0;
    }
  }

  &__after-groups {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 100%;
    height: 160px;
  }

  &__quarterfinal {
    position: absolute;
    bottom: 0;
    &_left {
      left: 0;
    }
    &_right {
      right: 0;
    }
  }

  &__semifinal {
    position: absolute;
    bottom: 0;
    &_left {
      left: 260px;
    }
    &_right {
      right: 260px;
    }
  }

  &__final {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
  }

  &__third {
    position: absolute;
    top: calc(100% + 30px);
    left: 50%;
    transform: translate(-50%);
  }

  &__winner {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 125px;
  }

  &__line {
    height: 2px;
    background-color: colors(palette-2);
    position: absolute;
    z-index: -1;

    &_semi {
      bottom: 36px;
      left: 260px;
      width: 650px;
    }

    &_final {
      bottom: 83px;
      left: calc(50% - 1px);
      width: 95px;
      transform: translate(-50%) rotate(90deg);
    }
  }
}
</style>
